import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { id } from '../interfaces/id.type';
import { isNotNull } from '../utils';
import * as TenantActions from './tenant.actions';
import {
  selectActiveTenants,
  selectSelectedTenant,
  selectSelectedTenantId,
  selectTenants,
} from './tenant.selectors';

@Injectable()
export class TenantService {
  private store = inject(Store);

  public get tenants$() {
    return this.store.select(selectTenants);
  }
  public get activeTenants$() {
    return this.store.select(selectActiveTenants);
  }
  public get selectedTenant$() {
    return this.store.select(selectSelectedTenant).pipe(filter(isNotNull));
  }
  public get selectedTenantId$() {
    return this.store.select(selectSelectedTenantId).pipe(filter(isNotNull));
  }

  loadPersonalTenants(): void {
    this.store.dispatch(TenantActions.loadPersonalTenants());
  }

  selectTenant(tenantId: id): void {
    this.store.dispatch(TenantActions.selectTenant({ tenantId }));
  }

  loadSelectedTenant(): void {
    this.store.dispatch(TenantActions.loadSelectedTenant());
  }
}
